module.exports = __webpack_public_path__ + "img/pc_footer_img.bc71e88.webp";